import axios, {AxiosError, AxiosResponse} from 'axios';
import queryString from 'query-string';
import {UserObject} from 'stores/UserStore';
import {ErrorObject} from 'types';

export type GetListParams = Partial<Pick<UserObject,
  | 'email'
  | 'username'
  | 'name'>> & {
  userID?: Partial<UserObject['id']>;
  title?: string;
  skip?: number;
  limit?: number;
}

/**
 * Get list of users
 * @param {GetListParams} params
 * @return {Promise<CourseObject[] | ErrorObject | undefined>}
 */
export async function getList(params?: GetListParams) {
  return axios({
    method: 'GET',
    url: queryString.stringifyUrl({
      url: `${process.env.REACT_APP_API_BASE_URL}/user/getList`,
      query: params && {
        ...params,
      },
    }),
  }).then((response: AxiosResponse<UserObject[]>) => (
    response.data
  )).catch((error: AxiosError<ErrorObject>) => (
    error.response?.data
  ));
}
